import { useState, useCallback } from 'react';
import { useLocation } from 'react-router';

export function useShortcutsModal() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  // Determine current page for context-specific shortcuts
  const getCurrentPage = () => {
    const pathname = location.pathname;
    if (pathname === '/orders') return 'orders';
    if (pathname === '/order-create') return 'create';
    if (pathname === '/order-edit') return 'edit';
    if (pathname === '/template') return 'template';
    return undefined;
  };

  return {
    isOpen,
    openModal,
    closeModal,
    currentPage: getCurrentPage()
  };
} 